import { DS_PROJECT_STATUS_LABEL } from '../constants/ds-project-status';

export class ProjectStatus {
  /**
   * Status value.
   */
  value: number;

  /**
   * Status label key.
   */
  label: string;

  /**
   * Status color.
   */
  color: string;

  /**
   * ProjectStatus constructor.
   *
   * @param value Status value.
   */
  constructor(value: number) {
    if (value || value === 0) {
      this.value = value;
      this.label = DS_PROJECT_STATUS_LABEL[value]?.label;
      this.color = DS_PROJECT_STATUS_LABEL[value]?.color;
    }
  }
}
